<template>
  <div :class="classes()" @click="$emit('click')">
    <div>
      <Copy v-if="headline" element="div" size="l" color="primaryBlue" bold>{{ headline }}</Copy>
      <Copy v-if="subline" :staticClass="`${el}__subline`" element="div" color="tertiaryLight">
        {{ subline }}
      </Copy>
    </div>
    <div :class="`${el}__careLevelWrapper`">
      <template v-if="calculatedCareLevel && careLevel">
        <template v-for="i in 5">
          <span
            v-if="i === 4"
            :class="`${el}__careLevel${reverseSquareSize ? ` ${el}__careLevel--small` : ''}`"
            :key="i"
          >
            {{ calculatedCareLevel }}
          </span>
          <span
            v-else
            :class="`${el}__square${reverseSquareSize && i === 3 ? ` ${el}__square--big` : ''}`"
            :key="i"
          >
            {{ i === 3 ? careLevel : null }}
          </span>
        </template>
      </template>
      <template v-else>
        <template v-if="centeredCareLevel">
          <span :class="`${el}__square`" />
          <span :class="`${el}__square`" />
        </template>
        <span :class="`${el}__careLevel`">{{ careLevel || '?' }}</span>
        <template v-if="centeredCareLevel">
          <span :class="`${el}__square`" />
          <span :class="`${el}__square`" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';

export default {
  name: 'CareLevelBar',
  props: {
    headline: {
      type: String,
    },
    subline: {
      type: String,
    },
    careLevel: {
      type: [Number, String],
    },
    calculatedCareLevel: {
      type: [Number, String],
    },
    centeredCareLevel: {
      type: Boolean,
    },
    light: {
      type: Boolean,
    },
    vertical: {
      type: Boolean,
    },
    reverseSquareSize: {
      type: Boolean,
    },
    careLevelColor: {
      type: String,
      default: null,
      validator: (val) => ['primaryCoral', 'secondaryMintLight'].includes(val),
    },
  },
  components: {
    Copy,
  },
  data() {
    return {
      el: 'c-careLevelBar',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.careLevelColor}`]: this.careLevelColor,
          [`${el}--light`]: this.light,
          [`${el}--vertical`]: this.vertical,
        };
      },
    };
  },
};
</script>
